<template>
  <div class="h-100 position-relative">
    <a-spin :spinning="trendLoading" class="dashboard-number-card h-100">
      <div class="dashboard-card-wrap">
        <div class="dashboard-card-header">
          <div class="dashboard-card-header-left" @click.alt="showDebuggerInfo = !showDebuggerInfo">{{ form.fd.name || $t('dashboard.text_6') }}
            <a-icon class="ml-2" type="loading" v-if="loading" />
            <a-tooltip v-if="isServersAnypool"><template slot="title">{{ $t('dashboard.server_tips') }}</template><icon type="help" /></a-tooltip>
          </div>
          <div class="dashboard-card-header-right">
            <span v-if="showDebuggerInfo">{{ `${$t('dashboard.text_20')}: ${form.fd.usage_key}` }}</span>
            <slot name="actions" :handle-edit="handleEdit" />
            <a class="ml-2" v-if="!edit && canShowEdit" @click="goPage">
              <icon type="arrow-right" style="font-size:18px" />
            </a>
          </div>
        </div>
        <div v-if="isTrend" class="dashboard-card-body dashboard-trend-cart">
            <div style="width:100%;height:100%">
              <div class="d-flex justify-content-between align-items-center">
                <div class="number-card-number mr-1 ">
                  {{ this.usage.usage }}{{ this.usage.unit }}
                </div>
              </div>
              <div class="trend-chart-container h-100">
                <ve-line
                  height="calc(100% - 10px)"
                  :data="chartData"
                  :extend="trendOptions"
                  :judge-width="true"
                  :resizeable="true"
                  :data-empty="isTrendDataEmpty" />
              </div>
            </div>
        </div>
        <div v-if="!isTrend" class="dashboard-card-body d-flex align-items-center justify-content-center w-100 heightCss dashboard-icon-cart">
          <div class="d-flex w-100 h-100 align-items-center justify-content-center">
            <div class="w-100 d-flex align-items-center justify-content-center h-100">
              <icon :type="params && params.icon ? params.icon : icons[0].type" :style="`font-size:${options.h * 23}px`" />
            </div>
            <div class="d-flex align-items-baseline w-100">
              <div class="number-card-number mr-1">{{ this.usage.usage }}</div>
              <div class="number-card-unit">{{ this.usage.unit }}</div>
            </div>
          </div>
        </div>
      </div>
    </a-spin>
    <base-drawer class="drawer-wrapper" @update:visible="updateVisible" :visible="visible" :title="$t('dashboard.text_5')" @ok="handleSubmit" @cancel="cancel">
      <a-form
        hideRequiredMark
        :form="form.fc"
        v-bind="formItemLayout">
        <slot />
        <a-form-item :label="$t('dashboard.text_6')">
          <a-input v-decorator="decorators.name" />
        </a-form-item>
        <quota-config
          :showTag="true"
          :fc="form.fc"
          :decorators="decorators"
          :usage-label="$t('dashboard.text_20')"
          @update:usage_key="setDefaultName" />
        <a-form-item v-if="canShowUnitConfig" :label="$t('common_250')">
          <base-select
              v-decorator="decorators.unit"
              isDefaultSelect
              :filterable="true"
              :options="unitOpts"
              :select-props="{ placeholder: $t('common_618') }" />
        </a-form-item>
        <a-form-item :label="$t('dashboard.chart_type')">
          <a-radio-group v-decorator="decorators.chart_type" @change="handleChartTypeChange">
            <a-radio-button value="trend">{{ $t('dashboard.trend') }}</a-radio-button>
            <a-radio-button value="icon">{{ $t('dashboard.icon') }}</a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item v-if="isTrend" :label="$t('dashboard.monitor.time')">
          <a-select v-decorator="decorators.time" @change="handleDateChange">
            <template v-for="item of dateArr">
              <a-select-option :key="item.key" :value="item.key">{{ item.value }}</a-select-option>
            </template>
          </a-select>
        </a-form-item>
        <a-form-item v-if="!isTrend" :label="$t('common_744')">
            <icon-picker
              v-decorator="decorators.icon"
              :options="icons"
              @updateIcon="updateIcon" />
        </a-form-item>
      </a-form>
    </base-drawer>
  </div>
</template>

<script>
// import TrendChart from 'vue-trend-chart'
import { mapGetters } from 'vuex'
import BaseDrawer from '@Dashboard/components/BaseDrawer'
import QuotaConfig from '@Dashboard/sections/QuotaConfig'
import { USAGE_CONFIG } from '@Dashboard/constants'
import { load } from '@Dashboard/utils/cache'
import { getRequestT } from '@/utils/utils'
import mixin from './mixin'
import { getUsageParams, getTrendOptions } from '../helper'

export default {
  name: 'NumberCardServer',
  components: {
    BaseDrawer,
    QuotaConfig,
    // TrendChart,
  },
  mixins: [mixin],
  props: {
    parmas: Object,
    edit: Boolean,
  },
  data () {
    const usage_key = this.$store.getters.isAdminMode ? 'all.servers' : this.$store.getters.isDomainMode ? 'domain.servers' : 'servers'
    const initialUsageKeyValue = ((this.params && this.params.type !== 'k8s') && this.params.usage_key) || usage_key
    const initialNameValue = ((this.params && this.params.type !== 'k8s') && this.params.name) || this.$t('usage')[initialUsageKeyValue]
    const initialRegionAccountType = ((this.params && this.params.type !== 'k8s') && this.params.regionAccountType) || 'region'
    const initUnitValue = (this.params && this.params.unit) || 'auto'
    const initChartType = (this.params && this.params.chart_type) || 'trend'
    const initTime = (this.time && this.params.time) || '30'
    return {
      data: {},
      loading: false,
      form: {
        fc: this.$form.createForm(this),
        fd: {
          name: initialNameValue,
          usage_key: initialUsageKeyValue,
          chart_type: initChartType,
          time: initTime,
          regionAccountType: initialRegionAccountType,
          schedtag: '',
          tags: [],
        },
        fi: {
          nameTouched: false,
        },
      },
      decorators: {
        name: [
          'name',
          {
            initialValue: initialNameValue,
            rules: [
              { required: true, message: this.$t('dashboard.text_8') },
            ],
          },
        ],
        cloud_env: [
          'cloud_env',
          {
            initialValue: this.params && this.params.cloud_env,
          },
        ],
        brand: [
          'brand',
          {
            initialValue: this.params && this.params.brand,
          },
        ],
        region: [
          'region',
          {
            initialValue: this.params && this.params.region,
          },
        ],
        regionAccountType: [
          'regionAccountType',
          {
            initialValue: initialRegionAccountType,
          },
        ],
        account: [
          'account',
          {
            initialValue: this.params && this.params.account,
          },
        ],
        usage_key: [
          'usage_key',
          {
            initialValue: initialUsageKeyValue,
            rules: [
              { required: true, message: this.$t('dashboard.text_22') },
            ],
          },
        ],
        unit: [
          'unit',
          {
            initialValue: initUnitValue,
          },
        ],
        chart_type: [
          'chart_type',
          {
            initialValue: 'trend',
          },
        ],
        time: [
          'time',
          {
            initialValue: '30',
            rules: [
              { required: true, message: this.$t('dashboard.text_76') },
            ],
          },
        ],
        icon: [
          'icon',
          {
            initialValue: this.params && this.params.icon,
          },
        ],
        schedtag: [
          'schedtag',
          {
            initialValue: this.params && this.params.schedtag,
          },
        ],
        tags: [
          'tags',
          {
            initialValue: this.params && this.params.tags,
          },
        ],
      },
      showDebuggerInfo: false,
      unitOpts: [
        { id: 'auto', name: this.$t('common_563') },
        { id: 'K', name: 'KB' },
        { id: 'M', name: 'MB' },
        { id: 'G', name: 'GB' },
        { id: 'T', name: 'TB' },
      ],
      currentUsageKey: initialUsageKeyValue,
      trendLoading: false,
      trendData: null,
      dateArr: [
        { key: '7', value: this.$t('scope.trend.date_7') },
        { key: '30', value: this.$t('scope.trend.date_30') },
      ],
      // selectedDate: '30',
      trendOptions: getTrendOptions(),
    }
  },
  computed: {
    ...mapGetters(['scope', 'userInfo']),
    usage () {
      const usage = (this.data && this.data[this.form.fd.usage_key]) || 0
      const ret = {
        usage,
      }
      const config = USAGE_CONFIG[this.form.fd.usage_key]
      // 使用默认单位
      if (config && config.formatter) {
        const fVal = config.formatter(usage)
        const fValArr = fVal.split(' ')
        ret.usage = fValArr[0]
        ret.unit = fValArr[1]
      }
      if (config && config.unit) {
        ret.unit = config.unit
      }
      // 使用用户配置的单位
      if (config && config.userUnitFormatter) {
        if (this.params && this.params.unit && this.params.unit !== 'auto') {
          const fVal = config.userUnitFormatter(usage, this.params.unit)
          const fValArr = fVal.split(' ')
          ret.usage = fValArr[0]
          ret.unit = fValArr[1]
        }
      }
      return ret
    },
    isServersAnypool () {
      if (!this.params) return false
      return ['all.servers.any_pool', 'domain.servers.any_pool', 'servers.any_pool', 'all.servers', 'domain.servers', 'servers'].includes(this.params.usage_key)
    },
    canShowEdit () {
      if (!this.params) return false
      return this.getPageUrl()
    },
    canShowUnitConfig () {
      const config = USAGE_CONFIG[this.currentUsageKey]
      if (config && config.canUseUserUnit) {
        return true
      }
      return false
    },
    chartData () {
      if (this.trendData && this.trendData.series) {
        const points = this.trendData.series[0].points.map(v => {
          return {
            date: v[1] + '',
            count: v[0],
          }
        })

        return {
          columns: ['date', 'count'],
          rows: points,
        }
      }
      return {
        columns: ['date', 'count'],
        rows: [],
      }
    },
    isTrendDataEmpty () {
      return this.chartData.rows.length === 0
    },
    isTrend () {
      return this.form.fd.chart_type === 'trend'
    },
  },
  watch: {
    'form.fd' (val) {
      const time = val.time || '30'
      this.fetchUsage()
      this.fetchResourceTrend(`${parseInt(time) * 24}h`)
      for (const key in this.decorators) {
        let config = this.decorators[key][1] || {}
        config = {
          ...config,
          initialValue: val[key],
        }
        this.decorators[key][1] = config
      }
    },
  },
  created () {
    if (this.params && this.params.type !== 'k8s') {
      this.form.fd = { ...this.form.fd, ...this.params }
    } else if (this.form.fd.usage_key) {
      this.form.fd.icon = this.params && this.params.icon ? this.params.icon : this.icons[0].type
      this.$emit('update', this.options.i, this.form.fd)
      this.setDefaultName(this.form.fd.usage_key)
      this.refresh()
    }
    this.$bus.$on('DashboardCardRefresh', args => {
      this.fetchUsage()
    }, this)
    // this.fetchResourceTrend()
  },
  methods: {
    updateIcon (val) {
      this.form.fc.setFieldsValue({
        icon: val,
      })
    },
    refresh () {
      this.fetchResourceTrend()
      return this.fetchUsage()
    },
    genUsageParams () {
      const params = {
        scope: this.scope,
        $t: getRequestT(),
      }
      const fd = this.form.fd
      if (fd.cloud_env) params.cloud_env = fd.cloud_env
      if (fd.region) {
        params.range_type = 'cloudregions'
        params.range_id = fd.region
      }
      if (fd.account) {
        params.range_type = 'cloudaccounts'
        params.range_id = fd.account
      }
      if (fd.brand) params.brand = fd.brand
      if (fd.schedtag) {
        params.range_type = 'schedtags'
        params.range_id = fd.schedtag
      }
      if (fd.tags?.length > 0) {
        params['project_tags.0.0.key'] = fd.tags[0].key
        params['project_tags.0.0.value'] = fd.tags[0].value
      }
      return params
    },
    async fetchUsage () {
      this.loading = true
      try {
        const params = this.genUsageParams()
        const data = await load({
          res: 'usages',
          action: 'rpc',
          actionArgs: {
            methodname: 'getGeneralUsage',
            params,
          },
          resPath: 'data',
        })
        this.data = data
      } catch (e) {
        throw e
      } finally {
        this.loading = false
      }
    },
    handleEdit (val) {
      this.updateVisible(true)
    },
    updateVisible (val) {
      this.$emit('update:visible', val)
    },
    async handleSubmit () {
      try {
        const values = await this.form.fc.validateFields()
        this.form.fd = values
        this.$emit('update', this.options.i, values)
        this.updateVisible(false)
      } catch (error) {
        throw error
      }
    },
    goPage () {
      if (!this.params) return
      const path = this.getPageUrl()
      if (path) this.$router.push(path)
    },
    getPageUrl () {
      switch (this.params.usage_key) {
        case 'all.servers':
          return '/vminstance'
        case 'servers':
          return '/vminstance'
        case 'domain.servers':
          return '/vminstance'
        case 'baremetals':
          return '/physicalmachine'
        case 'domain.baremetals':
          return '/physicalmachine'
        case 'hosts':
          return '/host'
        case 'domain.hosts':
          return '/host'
        case 'all.buckets':
          return '/bucket'
        case 'domain.buckets':
          return '/bucket'
        case 'all.cache':
          return '/redis'
        case 'domain.cache':
          return '/redis'
        case 'all.rds':
          return '/rds'
        case 'domain.rds':
          return '/rds'
        case 'all.loadbalancer':
          return '/lb'
        case 'domain.loadbalancer':
          return '/lb'
        case 'all.eip.floating_ip':
          return '/eip'
        case 'domain.eip.floating_ip':
          return '/eip'
        case 'all.snapshot':
          return '/disk-snapshot'
        case 'domain.snapshot':
          return '/disk-snapshot'
        case 'all.disks.count':
          return '/disk'
        case 'domain.disks.count':
          return '/disk'
        default:
          return ''
      }
    },
    async fetchResourceTrend (date) {
      try {
        const params = getUsageParams({
          indicator: this.form.fd.usage_key,
          scope: this.scope,
          date,
          userInfo: this.userInfo,
        })
        this.trendLoading = true
        const resData = await this.$http({
          url: '/v1/unifiedmonitors/query',
          method: 'post',
          params: {
            $t: getRequestT(),
          },
          data: params,
        })

        this.trendData = resData.data
      } finally {
        this.trendLoading = false
      }
    },
    handleDateChange (key) {
      // this.selectedDate = key
      this.fetchResourceTrend(`${parseInt(key) * 24}h`)
    },
    handleChartTypeChange (e) {
      this.form.fd.chart_type = e.target.value
    },
  },
}
</script>

<style lang="less" scoped>
.dashboard-trend-cart {
  .number-card-number {
    position: relative;
    top: -8px;
    width: 80px;
    font-size: 14px;
    font-weight: 500;
    line-height: 14px;
    color: #000000;
  }
}

.dashboard-icon-cart {
  .number-card-number {
    font-size: 60px;
    line-height: 48px;
    color: #000000;
  }
}

.number-card-date {
  position: relative;
  top: -8px;
  .ant-tag {
    padding: 0 2px;
    margin-right: 2px;
  }
}
.number-card-unit {
  font-size: 14px;
  color: #000000;
  margin-left: 5px;
}
.drawer-wrapper {
  &::v-deep.ant-drawer.ant-drawer-open .ant-drawer-mask {
    animation: none;
  }
}
.and-spin-container {
  height: 100%;
}
.heightCss{
  flex: 1;
  overflow: hidden;
}
.icon-content{
  width: 80px;
  height: 80px;
  margin:  5px;
  cursor: pointer;
  text-align: center;
  border-radius: 6px;
  border: 1px solid #ccc
}
.dashboard-icon {
  font-size: 77px;
}
</style>
